import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useRedirect = () => {
  const location = useLocation();

  // Lưu vị trí để redirect sau khi đăng nhập
  const saveRedirectPath = useCallback(() => {
    if (location.pathname !== '/auth/signin' && location.pathname !== '/unauthorized') {
      sessionStorage.setItem('redirectAfterLogin', location.pathname);
    }
  }, [location.pathname]);

  // Lấy URL để redirect sau khi đăng nhập
  const getRedirectAfterLogin = useCallback(() => {
    const redirectPath = sessionStorage.getItem('redirectAfterLogin');
    sessionStorage.removeItem('redirectAfterLogin');
    
    if (redirectPath && redirectPath !== '/auth/signin' && redirectPath !== '/unauthorized') {
      return redirectPath;
    }
    
    return '/dashboard';
  }, []);

  // Xóa redirect path
  const clearRedirectPath = useCallback(() => {
    sessionStorage.removeItem('redirectAfterLogin');
  }, []);

  return {
    saveRedirectPath,
    getRedirectAfterLogin,
    clearRedirectPath,
    currentPath: location.pathname
  };
};
